export const ACTIVATION_LINK_SUBJECT = "contact:activation_link"
export const BIKE_DESCRIPTION_SUBJECT = "contact:bike_description_error"
export const UPDATE_PARTNER_SUBJECT = "contact:update_partner"
export const UPDATE_BIKE_INFO_SUBJECT = "contact:update_bike_info"
export const BACK_STORE_BIKES_SUBJECT = "contact:back_store_bikes"
export const ARCADE_PARTNER_SUBJECT = "contact:arcade_partner"
export const CONSUMER_QUESTION_SUBJECT = "contact:consumer_question"
export const BUYING_TAG_SUBJECT = "contact:buying_tag"
export const BILLING_SUBJECT = "contact:billing"
export const OTHER_SUBJECT = "contact:other"

export const bcSubjectArray = [
	ACTIVATION_LINK_SUBJECT,
	BIKE_DESCRIPTION_SUBJECT,
	UPDATE_PARTNER_SUBJECT,
	ARCADE_PARTNER_SUBJECT,
	CONSUMER_QUESTION_SUBJECT,
	BACK_STORE_BIKES_SUBJECT,
	UPDATE_BIKE_INFO_SUBJECT,
	BUYING_TAG_SUBJECT,
	BILLING_SUBJECT,
	OTHER_SUBJECT,
]

export const mfcSubjectArray = [
	ACTIVATION_LINK_SUBJECT,
	BIKE_DESCRIPTION_SUBJECT,
	UPDATE_PARTNER_SUBJECT,
	CONSUMER_QUESTION_SUBJECT,
	BACK_STORE_BIKES_SUBJECT,
	UPDATE_BIKE_INFO_SUBJECT,
	BUYING_TAG_SUBJECT,
	OTHER_SUBJECT,
]

export const defaultSubjectArray = [
	ACTIVATION_LINK_SUBJECT,
	BIKE_DESCRIPTION_SUBJECT,
	UPDATE_PARTNER_SUBJECT,
	CONSUMER_QUESTION_SUBJECT,
	BACK_STORE_BIKES_SUBJECT,
	UPDATE_BIKE_INFO_SUBJECT,
	OTHER_SUBJECT,
]
